import axios, {
  Axios,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { BASEURL } from "../utils/helper";
import { apiPaths } from "../utils/apiUtils";

// Axios instance with base URL and headers
const axiosParams = {
  baseURL: BASEURL,
};

const axiosInstance = axios.create(axiosParams);

/*
 * No-op until the idle-session hook installs the real one via setResetCallback.
 * It used to log that it was not set yet, which fired on every response until the
 * hook mounted and said nothing anyone needed once it had.
 */
let resetCounter = () => {};

axiosInstance.interceptors.response.use(
  (response) => {
    resetCounter();
    return response;
  },
  (error) => {
    // Open access: a 401 means the anonymous session expired, so send the
    // applicant back to the start rather than to an identity provider.
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem("applicationId");
      if (window.location.pathname !== "/") {
        window.location.assign(`${window.location.origin}/`);
      }
    }
    if(error.response && error.response.status === 403)
      resetCounter();

    return Promise.reject(error);
  }
);

const api = (axios: Axios) => {
  return {
    get: (url: string, config: AxiosRequestConfig = {}) =>
      axios.get(url, { ...config, headers: { ...config.headers },withCredentials:true }),

    delete: (url: string, config: AxiosRequestConfig = {}) =>
      axios.delete(url, { ...config, headers: { ...config.headers },withCredentials:true }),

    post: (
      url: string,
      body: object,
      config: AxiosRequestConfig = {}
    ): Promise<AxiosResponse<any, any>> =>
      axios.post(url, body, { ...config, headers: { ...config.headers },withCredentials:true }),

    put: (url: string, body: object, config: AxiosRequestConfig = {}) =>
      axios.put(url, body, { ...config, headers: { ...config.headers },withCredentials:true }),
  };
};

// Function to set the reset callback from the custom hook
export function setResetCallback(callback: any) {
  resetCounter = callback;
}

export default api(axiosInstance);
